import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import DiseaseCodeForm from './DiseaseCodeForm';

const DiseaseCodeModal = ({ show, onHide, insprvalue, edittrigger, onCallParent }) => {
    const isEdit = insprvalue && insprvalue.id;

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Diagnosis' : 'Add Diagnosis'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <DiseaseCodeForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    insprvalue={insprvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

DiseaseCodeModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    insprvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default DiseaseCodeModal;
